import { inject } from "@angular/core";
import { ResolveFn } from "@angular/router";

import { AuthService } from "@azm/core/services/auth";

export const roleResolver: ResolveFn<string | null> = () => {
	const authService = inject(AuthService);
	return authService.userRoleName;
};
